import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import Modal from 'react-bootstrap/lib/Modal';
import { closeModal } from 'redux/modules/modal';

class ModalContainer extends PureComponent {
    static propTypes = {
        dialogStyle: PropTypes.object,
        dispatch: PropTypes.func.isRequired,
        data: PropTypes.element,
        onOpen: PropTypes.func,
        onClose: PropTypes.func,
        title: PropTypes.string,
        isVisible: PropTypes.bool.isRequired
    }

    state = {
        data: null,
        title: '',
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible && !nextProps.isVisible) {
            this.props.onClose();
        }
        else if (!this.props.isVisible && nextProps.isVisible) {
            this.setState({
                data: nextProps.data,
                title: nextProps.title,
            });

            nextProps.onOpen();
        }
    }

    handleCloseModal = () => {
        this.props.dispatch(closeModal());
    }

    exitedFinished = () => {
        this.setState({
            data: null,
            title: '',
        });
    }

    render() {
        return (
            <div>
                <Modal
                    id={'default-dialog-container'}
                    onHide={this.handleCloseModal}
                    onExited={this.exitedFinished}
                    show={this.props.isVisible}>
                    <Modal.Header closeButton={true}>
                        <Modal.Title>{this.state.title || ''}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.data}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps({ modal }) {
    return {
        dialogStyle: modal.activeModal.dialogStyle,
        data: modal.activeModal.data,
        onOpen: modal.activeModal.onOpen,
        onClose: modal.activeModal.onClose,
        title: modal.activeModal.title,
        isVisible: modal.isModalVisible
    };
}

export default connect(
    mapStateToProps
)(ModalContainer);



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js